import React, { useState, useEffect, useCallback } from "react";
import {
  IonItem,
  IonLabel,
  IonInput,
  IonImg,
  IonRow,
  IonCol,
  IonGrid,
  isPlatform,
} from "@ionic/react";
import _ from "lodash";
import { Anywhere, CityError, TIME_ZONE } from "../../../utils/constants";
import { GeographicalService, GPSWrapper } from "../../../utils/common";
import "../../../pages/Search/New/NewPage.scss";
import { getLocationDetails, removeDuplicates } from "../../../utils/origin-input.util";
import { LocationDetails, Coords } from "../../../schemas/Search/Search.schema";
import i18n from "i18n";
import useComponentVisible from "../../../utils/useOuterClick";
import { useDispatch } from "react-redux";
import { PcMilerSearchLocation } from "app/models/myLoad/tenderAction.model";
import { dispatchPcMillerRequest } from 'app/utils/pcMiller.util';

export interface NewInputProps {
  disabled?: boolean;
  currentLocationOff?: boolean;
  onTimeZoneChange?: (timezone: string) => void;
  Error: any;
  labelValue: any;
  InputValue: any;
  handleChange: any;
  InputName: any;
  keyboardshowHandler?: any;
  keyboardhideHandler?: any;
  isDestination: boolean;
  deFaultValue: any;
  useHandler: boolean;
  setErrorValue: any;
  locationValue: boolean;
  getLocalTime?: any;
  placeholder?: string;
  confirmStartLocationInp?: boolean;
  onFocus?: Function;
  country?: string;
  postalCode?: string;
}
export const NewInput: React.FC<NewInputProps> = ({
  disabled = false,
  currentLocationOff,
  onTimeZoneChange,
  Error,
  labelValue,
  InputValue,
  handleChange,
  InputName,
  getLocalTime,
  keyboardshowHandler,
  locationValue,
  keyboardhideHandler,
  deFaultValue,
  isDestination,
  useHandler,
  setErrorValue,
  placeholder,
  onFocus,
  country: selectedCountry = '',
  postalCode: selectedPostalCode = ""
}) => {
  const [options, setOptions] = useState([]);
  const [selectedCity, setSelectedCity] = useState(InputValue);
  const [latLng, setLatLng] = useState<Coords>({
    lat: "",
    lng: "",
  });
  const [showSuggention, setShowSuggention] = useState(false);
  const [edited, setEdited] = useState(false);
  const [palceholder, setPlaceholder] = useState(
    placeholder || ""
  );
  const [currentLocation, setcurrentLocation] = useState<LocationDetails>({
    cityName: "",
    country: "",
    postalCode: "",
    coords: {
      lat: "",
      lng: ""
    },
    timeZone: TIME_ZONE
  });
  const { ref, isComponentVisible } = useComponentVisible(true);
  const [showError, setShowError] = useState(false);
  const [backClicked, setBackClicked] = useState(true);
  const [country, setCountry] = useState("");
  const [postalCode, setPostalCode] = useState("");
  const [timezoneOffset, settimezoneOffset] = useState("");
  let valueSelected = false;
  const [select, setSelect] = useState(false);
  const [focusOut, setFocusOut] = useState(false);
  const pattern = /^[a-zA-Z0-9, ]*$/;
  const dispatch = useDispatch();

  const clearError = () => {
    setShowError(false);
    setErrorValue(false, InputName);
  }

  useEffect(() => {
    if (isPlatform("capacitor") && !currentLocationOff && currentLocationOff !== undefined) {
      GPSWrapper.details.getCurrentPosition((lat: any, long: any) => {
        fetchOriginCity(`${lat},${long}`);
        setLatLng({ lat, lng: long });
      });
    }
  }, [currentLocationOff]);

  useEffect(() => {
    const { cityName, country, postalCode, coords: { lat, lng } } = currentLocation;
    if (!isDestination && !edited && currentLocation.cityName && InputValue === deFaultValue) {
      setSelectedCity(cityName);
      setPlaceholder("");
      handleChange({
        target: {
          name: InputName,
          value: currentLocation.cityName,
          backClicked,
          lat,
          lng,
          country,
          currentLocation,
          postalCode: postalCode
        },
      });
    }
  }, [isDestination, edited, currentLocation]);

  useEffect(() => {
    if (edited && (country || postalCode || (latLng.lat && latLng.lng))) {
      handleChange({
        target: {
          name: InputName,
          value: selectedCity,
          backClicked,
          lat: latLng.lat,
          lng: latLng.lng,
          country,
          currentLocation,
          postalCode
        },
      });
    }
  }, [country, postalCode, latLng.lat, latLng.lng]);

  useEffect(() => {
    if (!locationValue) {
      setSelectedCity(deFaultValue);
    } else {
      setSelect(true);
      setSelectedCity(currentLocation.cityName);
    }
  }, [locationValue]);

  useEffect(() => {
    if (!InputValue) {
      setSelectedCity("");
    } else {
      setSelectedCity(InputValue);
    }
  }, [InputValue]);

  useEffect(() => {
    setShowError(Error);
  }, [Error]);

  const handleValueChange = (event: any) => {
    const preValue = selectedCity.trim();
    {
      /* Restrict user from entering special charecter */
    }
    if (!pattern.test(event.target.value) && !select) {
      event.target.value = event.target.value.replace(/[^a-zA-Z0-9 ]*/g, "");
    }
    setSelectedCity(event.target.value);
    setEdited(true);
    if (selectedCity !== event.target.value) {
      const newValue = event.target.value.trim();
      if (preValue !== newValue) {
        callAPI(event.target.value);
      }
    }
    if (edited) {

    }
    if (select) {
      handleChange({
        target: {
          name: InputName,
          value: event.target.value,
          backClicked,
          lat: latLng.lat,
          lng: latLng.lng,
          country,
          postalCode,
          timeZoneOffset : timezoneOffset
        },
      });
    } else {
      handleChange({
        target: {
          name: InputName,
          value: event.target.value,
          backClicked,
          lat: latLng.lat,
          lng: latLng.lng,
          country: selectedCountry,
          postalCode: selectedPostalCode,
          timeZoneOffset : timezoneOffset
        },
      });
      if (onTimeZoneChange) {
        onTimeZoneChange("");
      }
    }

    setSelect(false);
  };
  {
    /* to call azure api for city list need basis */
  }
  const callAPI = useCallback(
    _.debounce((value: string) => fetchCityList(value), 500),
    []
  );

  const fetchOriginCity = async (value: any) => {
    await GeographicalService.details.searchCurrentAddress(
      value,
      async (locations: any) => {
        const [location] = locations;
        const locationDetails = getLocationDetails(location);
        const { cityName, country, postalCode, coords: { lat, lng } = { lat: "", lng: "" }, timeZone } = locationDetails;
        setSelectedCity(cityName);
        setCountry(country);
        setPostalCode(postalCode);
        setcurrentLocation(locationDetails);
        clearError();
        onTimeZoneChange &&
          onTimeZoneChange(TIME_ZONE);
      });
  };

  const fetchCityList = async (value: any) => {
    if (value.length > 2) {
      await GeographicalService.details.searchAddress(value, async (locations: any) => {
        const cityList = locations
          .map((location: any) => getLocationDetails(location))
          .filter(({ cityName }: LocationDetails) => cityName !== currentLocation.cityName);
        const uniqueValues = removeDuplicates(cityList, "cityName");
        setOptions(uniqueValues);
        setShowSuggention(true);
        if (isDestination && useHandler) {
          keyboardshowHandler();
        }
        const searchedCity = uniqueValues.find((item: any) => item.cityName === value);
        if (searchedCity) {
          const { cityName, country, postalCode, coords: { lat, lng } = { lat: "", lng: "" }, timeZone } = searchedCity;
          setSelectedCity(cityName);
          setCountry(country);
          setPostalCode(postalCode);
          clearError();
          onTimeZoneChange &&
            onTimeZoneChange(TIME_ZONE);
          if (lat && lng) {
            setLatLng({ lat, lng });
          }
        }
      });
      
    } else {
      setShowSuggention(false);
      if (isDestination && useHandler) {
        keyboardhideHandler();
      }
    }
  };

  const selectCity = async (SearchCity: LocationDetails) => {
    const { cityName, country = "", postalCode = "", coords: { lat, lng } = { lat: "", lng: "" }, timeZone } = SearchCity;
    setCountry(country);
    setPostalCode(postalCode);
    setShowSuggention(false);
    setSelect(true);
    setSelectedCity(cityName);
    settimezoneOffset(timeZone && timeZone.substr(3,5))
    if (isDestination && useHandler) {
      keyboardhideHandler();
    }
    onTimeZoneChange &&
    onTimeZoneChange(TIME_ZONE);
    if (lat && lng) {
      setLatLng({ lat, lng });
    }
  };
  const onFocusOut = () => {
    setFocusOut(true);
    setPlaceholder(placeholder || '');
    valueSelected = options.some((item: any) => item.cityName === selectedCity);
    if (isDestination && useHandler) {
      keyboardhideHandler();
    }
    if (!valueSelected) {
      if (
        selectedCity === currentLocation.cityName ||
        (isDestination && selectedCity === deFaultValue)
      ) {
        setShowError(false);
        setErrorValue(false, InputName);
      } else {
        setShowError(true);
        setErrorValue(true, InputName);
      }
      if (selectedCity.length === 0) {
        setShowError(true);
        setErrorValue(true, InputName);
      }
    } else {
      setShowError(false);
      setErrorValue(false, InputName);
    }
    setBackClicked(false);
  };

  const originClick = (e: any) => {
    if (
      focusOut ||
      currentLocation.cityName === selectedCity ||
      (selectedCity === Anywhere)
    ) {
      setSelectedCity("");
      setEdited(true);
      setBackClicked(true);
      setFocusOut(false);
    }
  };

  const handleFocus = () => {
    setPlaceholder("");
    onFocus && onFocus();
  };
  useEffect(() => {
    isComponentVisible === false && setShowSuggention(false)
  }, [isComponentVisible])

  return (
    <>
      <IonItem
        ref={ref}
        mode="ios"
        className={`typeahead-item ${
          Error || showError
            ? "ion-error-field-validation"
            : "ion-field-validation"
          }`}
      >
        {labelValue.length > 0 ? (
          <IonLabel mode="ios" position="floating">
            {labelValue}
          </IonLabel>
        ) : null}

        <IonInput
          type="text"
          disabled={disabled}
          className="cts-form-control"
          data-testid="inputDestinationCity"
          name={InputName}
          onIonChange={event => handleValueChange({
            target: {
              name: InputName,
              value: event.detail.value,
            }})
          }
          value={selectedCity}
          placeholder={palceholder}
          onIonFocus={handleFocus}
          onIonBlur={() => onFocusOut()}
          onClick={(event: any) => originClick(event)}
          autocomplete={"none" as any}
        >

        </IonInput>
        <i className="down"></i>

      </IonItem>
      <div className="pickupdate-error">
        {typeof Error === "string" ? (
          <p>{Error}</p>
        ) : showError ? (
          <p>{i18n.t(CityError)}</p>
        ) : null}
      </div>
      {showSuggention ? (
        <div
          className={` ${
            locationValue ? "suggestion-startTrip" : "suggestions_div "
            }`}
        >
          <IonRow className="suggestions_row">
            {!locationValue ? (
              currentLocation.cityName ? (
                <IonCol class="icon-col">
                  <IonImg
                    alt="logo"
                    src="/assets/icon/position.svg"
                    className="position_icon"
                  />
                </IonCol>
              ) : null
            ) : null}
            <IonCol class="suggestion-col">
              {currentLocation.cityName ? (
                <IonRow
                  className={` ${
                    locationValue ? "current-location2" : "current-location "
                    }`}
                  onMouseDown={() =>
                    currentLocation && selectCity(currentLocation)
                  }
                >
                  <IonCol className="currentLocation-col">
                    {!locationValue ? (
                      <IonLabel position="floating">Current Location</IonLabel>
                    ) : null}
                    <IonInput
                      className={`${
                        locationValue ? "suggestion-border" : "cts-form-control"
                        }`}
                      type="text"
                      value={
                        locationValue ? InputValue : currentLocation.cityName
                      }
                      readonly
                      autocomplete={"none" as any}
                    />
                  </IonCol>
                </IonRow>
              ) : null}

              {options.length ? (
                <IonGrid
                  class={`suggestions ${
                    locationValue ? "suggestions-pad" : ""
                    }`}
                >
                  {options.map((SearchCity: any, index: number) => (
                    <IonRow
                      className="suggestions_item"
                      key={index}
                      onMouseDown={() => selectCity(SearchCity)}
                    >
                      <IonCol class="suggestions_list">
                        {SearchCity.cityName}
                      </IonCol>
                    </IonRow>
                  ))}
                </IonGrid>
              ) : (
                  !locationValue && (
                    <div className="pickupdate-error">
                      <p>{i18n.t("CityError")}</p>
                    </div>
                  )
                )}
            </IonCol>
          </IonRow>
        </div>
      ) : null}
    </>
  );
};
